"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressLabel = void 0;
var react_1 = __importStar(require("react"));
var style_1 = require("./style");
var ProgressLabel = (function (_super) {
    __extends(ProgressLabel, _super);
    function ProgressLabel(props) {
        return _super.call(this, props) || this;
    }
    ProgressLabel.prototype.createSegment = function (total, segment) {
        var segmentResult = react_1.default.createElement("div", null, "default");
        var percent = (segment.amount * 100) / total;
        switch (segment.type) {
            case 'first':
                segmentResult = (react_1.default.createElement(style_1.ProgressLabelSegmentFirst, { key: segment.key, Width: "".concat(percent, "%") },
                    react_1.default.createElement(style_1.SpanText, null, "".concat(segment.amount, " ").concat(segment.label))));
                break;
            case 'last':
                segmentResult = (react_1.default.createElement(style_1.ProgressLabelSegmentLast, { key: segment.key, Width: "".concat(percent, "%") },
                    react_1.default.createElement(style_1.SpanText, null, "".concat(segment.amount, " ").concat(segment.label))));
                break;
            case 'unique':
                segmentResult = (react_1.default.createElement(style_1.ProgressLabelSegmentUnic, { key: segment.key, Width: "".concat(percent, "%") },
                    react_1.default.createElement(style_1.SpanText, null, "".concat(segment.amount, " ").concat(segment.label))));
                break;
            case 'center':
                segmentResult = (react_1.default.createElement(style_1.ProgressLabelSegmentCenter, { key: segment.key, Width: "".concat(percent, "%") },
                    react_1.default.createElement(style_1.SpanText, null, "".concat(segment.amount, " ").concat(segment.label))));
                break;
        }
        return segmentResult;
    };
    ProgressLabel.prototype.render = function () {
        var _this = this;
        var _a = this.props, total = _a.total, segments = _a.segments;
        var segmentsRender = segments.map(function (segment) {
            return _this.createSegment(total, segment);
        });
        return react_1.default.createElement(style_1.ProgressLabelSegment, null, segmentsRender);
    };
    return ProgressLabel;
}(react_1.Component));
exports.ProgressLabel = ProgressLabel;
